module.exports = __webpack_public_path__ + "img/icon_heart_5.17ea71f7.svg";